import { render, staticRenderFns } from "./index.vue?vue&type=template&id=26b6f5a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=26b6f5a8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6f5a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b6f5a8')) {
      api.createRecord('26b6f5a8', component.options)
    } else {
      api.reload('26b6f5a8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=26b6f5a8&scoped=true", function () {
      api.rerender('26b6f5a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/organization/index.vue"
export default component.exports